/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Faq_Lockin_DetailInputs */

const en_marketing_faq_lockin_detail = /** @type {(inputs: Marketing_Faq_Lockin_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onyx is Cloudflare by default, portable by design. Capabilities live in focused packages behind small interfaces, so swapping the storage, database, or deploy target is contained work, not a rewrite.`)
};

const es_marketing_faq_lockin_detail = /** @type {(inputs: Marketing_Faq_Lockin_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onyx usa Cloudflare por defecto y es portable por diseño. Las capacidades viven en paquetes enfocados tras interfaces pequeñas, así que cambiar el almacenamiento, la base de datos o el destino del despliegue es un trabajo acotado, no una reescritura.`)
};

const fr_marketing_faq_lockin_detail = /** @type {(inputs: Marketing_Faq_Lockin_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onyx est Cloudflare par défaut et portable par conception. Les capacités vivent dans des paquets ciblés derrière de petites interfaces : changer le stockage, la base de données ou la cible de déploiement est un travail circonscrit, pas une réécriture.`)
};

/**
* | output |
* | --- |
* | "Onyx is Cloudflare by default, portable by design. Capabilities live in focused packages behind small interfaces, so swapping the storage, database, or deplo..." |
*
* @param {Marketing_Faq_Lockin_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_faq_lockin_detail = /** @type {((inputs?: Marketing_Faq_Lockin_DetailInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Faq_Lockin_DetailInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_faq_lockin_detail(inputs)
	if (locale === "es") return es_marketing_faq_lockin_detail(inputs)
	return fr_marketing_faq_lockin_detail(inputs)
});